const t = { ROUTER: { title: "Оновлюємо додаток!", description: "Це варте того, щоб зачекати." }, UNKNOWN: { title: "Ой, щось пішло не так!", description: "Спробуйте перезавантажити сторінку або зверніться до адміністратора." } };
export {
  t as ERROR_MESSAGES
};
//# sourceMappingURL=utils.js.map
